import MainCard from 'components/CandidateStatusCards/MainCard';
import StatusCard from 'components/CandidateStatusCards/StatusCard';
import FullScreenLoading from 'components/FullScreenLoading';
import {AuthContext} from 'context/Auth.context';
import {CandidateContext} from 'context/Candidate.context';
import {useContext, useEffect, useState} from 'react';
import SERVICES from 'services';
import './Home.less';

const Home = ({regIsOpen}: any) => {
	const [exams, setExams] = useState([]);
	const [loading, setLoading] = useState(true);

	const {
		state: {statusID}
	} = useContext(CandidateContext);

	const {
		state: {student}
	} = useContext(AuthContext);

	const role = student ? 'STUDENT' : 'CANDIDATE';

	const getExams = () => {
		setLoading(true);
		SERVICES.USER.getExams(role)
			.then(res => {
				setExams(res.data);
			})
			.finally(() => {
				setLoading(false);
			});
	};

	useEffect(() => {
		getExams();
	}, []);

	if (loading) return <FullScreenLoading />;

	return (
		<div className="container">
			<MainCard regIsOpen={regIsOpen} />
			<StatusCard exams={exams} getExams={getExams} statusID={statusID} />
		</div>
	);
};

export default Home;
